const moduleMap = {
	"./Pages": () => {
		return Promise.all([__webpack_require__.e(74673), __webpack_require__.e(20561), __webpack_require__.e(1043), __webpack_require__.e(43801), __webpack_require__.e(50072), __webpack_require__.e(20963), __webpack_require__.e(5989), __webpack_require__.e(30735), __webpack_require__.e(82064), __webpack_require__.e(30432), __webpack_require__.e(21536), __webpack_require__.e(90484), __webpack_require__.e(95717), __webpack_require__.e(63842), __webpack_require__.e(72706), __webpack_require__.e(87578), __webpack_require__.e(23285), __webpack_require__.e(63673)]).then(() => (() => ((__webpack_require__(563673)))));
	},
	"./Reducers": () => {
		return Promise.all([__webpack_require__.e(95717), __webpack_require__.e(37971), __webpack_require__.e(24733)]).then(() => (() => ((__webpack_require__(824733)))));
	},
	"./Router": () => {
		return Promise.all([__webpack_require__.e(74673), __webpack_require__.e(20561), __webpack_require__.e(1043), __webpack_require__.e(43801), __webpack_require__.e(50072), __webpack_require__.e(20963), __webpack_require__.e(5989), __webpack_require__.e(30735), __webpack_require__.e(82064), __webpack_require__.e(30432), __webpack_require__.e(21536), __webpack_require__.e(90484), __webpack_require__.e(95717), __webpack_require__.e(63842), __webpack_require__.e(72706), __webpack_require__.e(87578), __webpack_require__.e(23285), __webpack_require__.e(52218)]).then(() => (() => ((__webpack_require__(252218)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});